import {Injectable} from '@angular/core';
import {Subject} from 'rxjs';
import i18next from 'i18next';

@Injectable({
  providedIn: 'root'
})
export class CollectionsService {
  currency = new Intl.NumberFormat('de-DE', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });
  currencyCode!: string;
  dataLoaded = false;
  data: any;
  translations: any;
  articlesData: any[] = [];

  constructor() {
  }

  public _collectionsData: any;

  get collectionsData(): any[] {
    return this._collectionsData;
  }

  get highlightsData(): any[] {
    return Object.values(this.collectionsData).filter(c => c.highlight_sorting > 0);
  }

  get teaserData(): any[] {
    return Object.values(this.collectionsData).filter(c => c.teaser > 0);
  }

  private _loadDataSub = new Subject<any>();

  loadDataObservable$ = this._loadDataSub.asObservable();

  get loadDataSub(): Subject<any> {
    return this._loadDataSub;
  }

// Collections -----------------------

  getCollections(): any {
    return this._collectionsData;
  }

  getCollectionData(collectionId: string): any {
    return this._collectionsData[collectionId];
  }

  getProductCountFromCollection(collectionId: string): number {
    return Object.values(this.articlesData).filter(c => c.collection === Number(collectionId)).length;
  }

  // Products -----------------------

  getProducts(): any {
    return this.articlesData;
  }

  getHighestVolume(): number {
    console.log(Math.max(...Object.values(this.articlesData).map(article => Number(i18next.t(article.texts.volume)))));
    return Math.max(...Object.values(this.articlesData).map(article => Number(i18next.t(article.texts.volume))));
  }

  getLowestVolume(): number {
    console.log(Math.min(...Object.values(this.articlesData).map(article => Number(i18next.t(article.texts.volume)))));
    return Math.min(...Object.values(this.articlesData).map(article => Number(i18next.t(article.texts.volume))));
  }

  getLowestDiameter(): number {
    console.log(Math.min(...Object.values(this.articlesData).map(article => Number(i18next.t(article.texts.diameter)))));
    return Math.min(...Object.values(this.articlesData).map(article => Number(i18next.t(article.texts.diameter))));
  }

  getHighestDiameter(): number {
    console.log(Math.max(...Object.values(this.articlesData).map(article => Number(i18next.t(article.texts.diameter)))));
    return Math.max(...Object.values(this.articlesData).map(article => Number(i18next.t(article.texts.diameter))));
  }

  getHighestPrice(): number {
    return Math.max(...Object.values(this.articlesData).map(article => article.price));
  }

  getLowestPrice(): number {
    return Math.min(...Object.values(this.articlesData).map(article => article.price));
  }


  getProductsDataFromCollection(collectionId: string): any[] {
    return Object.values(this.articlesData).filter(c => c.collection === Number(collectionId));
  }

  getProductData(productId: number): any {
    return this.articlesData[productId];
  }
  
  emitLoadDataSuccess(): void {
    this._loadDataSub.next();
  }

  getCrossSellingProducts(productId: number): any[] {
    const crossSellingProductsIds = this.getProductData(productId).x_article;
    const crossSellingProducts: any = [];
    crossSellingProductsIds.forEach((value: any) => {
      const product = Object.values(this.articlesData).find((p: { sku: string; }) => p.sku === value);
      crossSellingProducts.push(product);
    });
    console.log(crossSellingProducts);
    return crossSellingProducts;
  }

}
